import React from "react";
import { Route, Redirect } from "react-router-dom";

import { applyAuthToken } from "../utils/authToken";
import CookieInstance from "../utils/cookie";

const AuthenticatedRoute = ({ component: Component, location, ...rest }) => {
  const currentLocation = location || window.location;
  const params = new URLSearchParams(currentLocation.search);
  const token = params.get("token");

  if (token) {
    const { ok } = applyAuthToken(token);

    // Invalid or expired token link: wipe state (done inside applyAuthToken)
    // and send the user to login with their intended destination preserved.
    if (!ok) {
      return (
        <Route
          {...rest}
          render={() => (
            <Redirect
              to={{
                pathname: "/pilot/login",
                state: { from: currentLocation.pathname },
              }}
            />
          )}
        />
      );
    }

    return (
      <Route
        {...rest}
        render={() => (
          <Redirect
            to={{
              pathname: currentLocation.pathname,
            }}
          />
        )}
      />
    );
  }

  if (
    CookieInstance.checkCookie(process.env.REACT_APP_COOKIE_NAME || "userToken")
  ) {
    return (
      <Route {...rest} render={(props) => <Component {...props} {...rest} />} />
    );
  }
  return (
    <Route
      {...rest}
      render={(props) => (
        <Redirect
          to={{
            pathname: "/pilot/login",
            state: { from: props.locations },
          }}
          {...rest}
        />
      )}
    />
  );
};

export default AuthenticatedRoute;
